export const imageCodes = {
  contact_Bg: {
    code: "${merchant}_tmpl_img_24",
    image:
      "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fherobg.jpg?alt=media&token=9fda26d6-a664-4e7c-ac7e-a1cdf71f93b7",
  },
};

export const titleCodes = {
  contactTitle: {
    code: "${merchant}_tmpl_title_7",
    title: "Contact Us",
  },
};

export const textCodes = {
  fbTitle: {
    code: "${merchant}_tmpl_text_1",
    text: "facebook:",
  },

  phTitle: {
    code: "${merchant}_tmpl_text_23",
    text: "phone number:",
  },

  emailTitle: {
    code: "${merchant}_tmpl_text_25",
    text: "email:",
  },

  fbText: {
    code: "${merchant}_tmpl_text_22",
    text: "https://www.facebook.com/cetaphilmyanmar",
  },

  phText: {
    code: "${merchant}_tmpl_text_24",
    text: "+95 9 262 227011",
    text2: "+95 9 786 255761",
    text3: "+95 9 421 055333",
  },

  emailText: {
    code: "${merchant}_tmpl_text_26",
    text: "snowprize@gmail.com",
  },
  addressText: {
    text: "အမှတ် ၆၀ အသောကနှင့် မြန်မာ့ဂုဏ်ရောင်လမ်းထောင့် နတ်ချောင်းရက်ကွက် တာမွေ(Genius စာသင်ကျောင်းရှေ့)",
  },
};
